export { default } from './ViewCompositionHeader';
